"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mixpanelEvents = void 0;
exports.mixpanelEvents = {
    BUTTON_CLICK: 'BUTTON_CLICK',
    TAB_INITIATE: 'TAB_INITIATE',
    TAB_CHANGE: 'TAB_CHANGE',
    DATE_RANGE_CHANGE: 'DATE_RANGE_CHANGE',
    PAGINATION_CLICK: 'PAGINATION_CLICK',
    TABLE_LOAD: 'TABLE_LOAD',
    TABLE_ROW_CLICK: 'TABLE_ROW_CLICK',
    TABLE_COLUMN_CLICK: 'TABLE_COLUMN_CLICK',
    TABLE_HEADER_CLICK: 'TABLE_HEADER_CLICK',
    DROPDOWN_CHANGE: 'DROPDOWN_CHANGE',
    CHECKBOX_CHANGE: 'CHECKBOX_CHANGE',
    TOGGLE_SWITCH_CHANGE: 'TOGGLE_SWITCH_CHANGE',
    INPUT_CHANGE: 'INPUT_CHANGE',
    PROGRESS_LINE_LOAD: 'PROGRESS_LINE_LOAD',
    MENU_LIST_RESET_CLICK: 'MENU_LIST_RESET_CLICK',
    MENU_LIST_OPTION_CLICK: 'MENU_LIST_OPTION_CLICK',
    DRAGGABLE_LIST_DRAG_START: 'DRAGGABLE_LIST_DRAG_START',
    DRAGGABLE_LIST_DRAG_ENTER: 'DRAGGABLE_LIST_DRAG_ENTER',
    CHIP_REMOVE: 'CHIP_REMOVE',
    RADIO_LIST_CLICK: 'RADIO_LIST_CLICK',
    RADIO_CLICK: 'RADIO_CLICK',
    RADIO_BUTTON_CLICK: 'RADIO_BUTTON_CLICK',
    ALERT_CLOSE_CLICK: 'ALERT_CLOSE_CLICK',
};
